import { css } from "@emotion/react";
import { Button, Theme, useTheme } from "@mui/material";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";

import MobileDatabasePanel from "~/components/common/MobileDatabasePanel";
import { Props } from "~/components/database/page/index/lib";
import { useActivityLogger } from "~/lib/client/logger/useActivityLogger";

const MobilePage = ({ forms }: Props) => {
  const theme = useTheme();
  const router = useRouter();
  const logger = useActivityLogger();

  const handleOnClick = async () => {
    if (!logger) return;

    await logger({
      actionName: "click_create_database",
      pageName: "databaseIndex",
    });
    await router.push("/database/create");
  };

  return (
    <main css={rootStyle}>
      <h2>新着のデータベース</h2>
      <Button onClick={handleOnClick}>データベースを作る</Button>
      <Link href={"/database/create"} css={databaseLinkStyle(theme)}>
        データベースを作る
      </Link>
      <div css={formContainerStyle}>
        {forms.map((form, i) => (
          <MobileDatabasePanel
            database={{ ...form, postSize: form.responses.length }}
            key={i}
          />
        ))}
      </div>
    </main>
  );
};

const rootStyle = css`
  display: flex;
  flex-flow: column;
  margin: 0 12px 0 12px;
`;

const formContainerStyle = css`
  margin-top: 12px;
  display: flex;
  flex-flow: column wrap;
  gap: 12px;
  padding-bottom: 0.75rem;
`;

const databaseLinkStyle = (theme: Theme) => css`
  color: ${theme.palette.primary.main};
  text-decoration: underline;
`;

export default MobilePage;
